import type { AppLocale } from '@/shared/lib';

type Bundle = Record<string, unknown>;

/**
 * Lazy translation loaders: one chunk per locale × namespace.
 *
 * Nothing here is bundled eagerly — a page requests only the namespaces its
 * components use, in its own language, so an English page never downloads
 * Ukrainian or Russian strings and a Ukrainian page never downloads English.
 */
const loaders = import.meta.glob<Bundle>('./*/*.json', { import: 'default' });

/** Namespace names, read from the canonical locale's file names. */
export const NAMESPACES = Object.keys(loaders)
  .filter((path) => path.startsWith('./uk/'))
  .map((path) => path.slice('./uk/'.length, -'.json'.length));

export const loadNamespace = (locale: AppLocale, namespace: string): Promise<Bundle> => {
  const load = loaders[`./${locale}/${namespace}.json`];
  return load ? load() : Promise.reject(new Error(`Missing namespace ${locale}/${namespace}`));
};
